import React, { Component } from 'react';
import Routes from '../../routes/Routes';
import NavbarComponent from '../Navbar/Navbar';
import Footer from '../footer/Footer';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/jelly.css';
import { resetLocalStorage } from '../../utils/utils';

export default class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            isAdmin: false,
            isManager: false,
            isUser: false,
            isSuperAdmin: false,
            employeeData: undefined
        };
    }

    componentDidMount() {
        resetLocalStorage();

        const isAuthenticated = sessionStorage.getItem('authenticated'),
            setEmployeeData = sessionStorage.getItem('user'),
            userHasAdmin = sessionStorage.getItem('admin'),
            userHasManager = sessionStorage.getItem('manager'),
            userHasUser = sessionStorage.getItem('user'),
            userHasSuperAdmin = sessionStorage.getItem('superAdmin');

        if (
            isAuthenticated &&
            setEmployeeData &&
            (userHasAdmin || userHasManager || userHasUser || userHasSuperAdmin)
        ) {
            this.setState({
                isAuthenticated: JSON.parse(isAuthenticated)
            });
            this.setState({
                employeeData: JSON.parse(setEmployeeData)
            });
            if (userHasAdmin)
                this.setState({
                    isAdmin: JSON.parse(userHasAdmin)
                });
            if (userHasManager)
                this.setState({
                    isManager: JSON.parse(userHasManager)
                });
            if (userHasUser)
                this.setState({
                    isUser: JSON.parse(userHasUser)
                });
            if (userHasSuperAdmin)
                this.setState({
                    isSuperAdmin: JSON.parse(userHasSuperAdmin)
                });
        }
    }

    userHasAuthenticated = authenticated => {
        sessionStorage.setItem('authenticated', JSON.stringify(authenticated));
        this.setState({
            isAuthenticated: authenticated
        });
    };
    userHasAdmin = admin => {
        sessionStorage.setItem('admin', JSON.stringify(admin));
        this.setState({ isAdmin: admin });
    };
    userHasUser = user => {
        sessionStorage.setItem('user', JSON.stringify(user));
        this.setState({ isUser: user });
    };
    userHasManager = manager => {
        sessionStorage.setItem('manager', JSON.stringify(manager));
        this.setState({ isManager: manager });
    };
    userHasSuperAdmin = superAdmin => {
        sessionStorage.setItem('superAdmin', JSON.stringify(superAdmin));
        this.setState({
            isSuperAdmin: superAdmin
        });
    };
    setEmployeeData = employeeData => {
        sessionStorage.setItem('employeeData', JSON.stringify(employeeData));
        this.setState({
            employeeData: employeeData
        });
    };

    render() {
        const childProps = {
            isAuthenticated: this.state.isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated,
            userHasAdmin: this.userHasAdmin,
            isAdmin: this.state.isAdmin,
            isManager: this.state.isManager,
            userHasManager: this.userHasManager,
            isUser: this.state.isUser,
            userHasUser: this.userHasUser,
            employeeData: this.state.employeeData,
            setEmployeeData: this.setEmployeeData,
            userHasSuperAdmin: this.userHasSuperAdmin,
            isSuperAdmin: this.state.isSuperAdmin
        };

        return (
            <div
                className={
                    'main-container' +
                    (this.state.isAuthenticated ? ' auth-page' : '')
                }
            >
                <NavbarComponent childProps={childProps} />
                <div className={'main-grid-page'}>
                    <Routes childProps={childProps} />
                </div>
                <Footer />
                <Alert stack={{ limit: 3 }} timeout={3000} effect={'jelly'} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/App/App.js